import { Droplets, Route, Sparkles, Truck } from 'lucide-react';
import { ACTIVE_ROUTES } from './mockComplianceData';

function SalikBreakdown({ gates, total }) {
  return (
    <div>
      <div className="flex flex-wrap gap-1">
        {gates.map((gate) => (
          <span
            key={gate.name}
            className="inline-flex rounded-md bg-white px-1.5 py-0.5 text-[10px] text-logi-muted ring-1 ring-logi-grid"
          >
            {gate.name} · {gate.aed} AED
          </span>
        ))}
      </div>
      <p className="mt-1 font-mono text-sm font-semibold text-amber-700">
        {total} <span className="text-xs text-logi-text0">AED total</span>
      </p>
    </div>
  );
}

export default function SalikFuelPredictor({ routes = ACTIVE_ROUTES }) {
  const optimizedCount = routes.filter((r) => r.aiOptimized).length;

  return (
    <section className="overflow-hidden rounded-2xl border border-logi-grid bg-white backdrop-blur-sm">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-logi-grid px-5 py-4">
        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50 ring-1 ring-emerald-500/20">
            <Route className="h-4 w-4 text-emerald-700" strokeWidth={1.75} />
          </div>
          <div>
            <h2 className="text-sm font-bold text-logi-text">AI Salik Toll &amp; Fuel Cost Predictor</h2>
            <p className="text-xs text-logi-text0">
              Route-level toll &amp; fuel forecasting · {optimizedCount} AI-optimized
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700 ring-1 ring-emerald-500/25">
          <Sparkles className="h-3.5 w-3.5" />
          AI Engine Active
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-left text-sm">
          <thead>
            <tr className="border-b border-logi-grid/80 text-xs uppercase tracking-wider text-logi-text0">
              <th className="px-5 py-3 font-semibold">Route Name</th>
              <th className="px-5 py-3 font-semibold">Active Tanker</th>
              <th className="px-5 py-3 font-semibold">Predicted Salik Tolls</th>
              <th className="px-5 py-3 font-semibold">Est. Trip Fuel</th>
              <th className="px-5 py-3 font-semibold">AI Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-logi-grid/30">
            {routes.map((route) => (
              <tr key={route.id} className="transition-colors hover:bg-white">
                <td className="px-5 py-3.5">
                  <p className="font-semibold text-white">{route.routeName}</p>
                  <p className="text-xs text-logi-text0">{route.id}</p>
                </td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1.5 font-mono text-sm text-logi-accent">
                    <Truck className="h-3.5 w-3.5" />
                    {route.tankerId}
                  </span>
                </td>
                <td className="px-5 py-3.5">
                  <SalikBreakdown gates={route.salikGates} total={route.totalSalikAed} />
                </td>
                <td className="px-5 py-3.5">
                  <div className="flex items-center gap-1.5">
                    <Droplets className="h-3.5 w-3.5 text-amber-700/70" />
                    <span className="font-mono text-sm text-white">
                      {route.fuelLiters.toLocaleString()} L
                    </span>
                  </div>
                  <p className="mt-0.5 font-mono text-xs text-emerald-700">
                    {route.fuelCostAed.toLocaleString()} AED
                  </p>
                </td>
                <td className="px-5 py-3.5">
                  {route.aiOptimized ? (
                    <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-emerald-700 ring-1 ring-emerald-500/30">
                      <Sparkles className="h-3 w-3" />
                      AI Optimized Route
                    </span>
                  ) : (
                    <span className="inline-flex rounded-full bg-white px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-logi-muted ring-1 ring-logi-grid">
                      Standard Route
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
